module.exports = __webpack_public_path__ + "img/Rectangle@2x.040c5571.png";